import React, { useState, useMemo, useEffect } from "react";
import AdminDashboardLayout from "./AdminDashboardLayout";
import { GET_ALL_ADMIN_ADVERTISER } from "../components/GraphQL/Queries";
import { useQuery } from "@apollo/client";
import { Box, Center, ChakraProvider } from "@chakra-ui/react";
import { TableSpinner } from "../components/Spinner";
import "./css/admin_advertiser.css";
import AdminTab from "../components/AdminTab/AdminTab";
import AdminTable from "../components/AdminTable/AdminTable";
import { useNavigate } from "react-router-dom";

const AdminAdvertiser = () => {
  const [selectedTab, setSelectedTab] = useState("ALL");
  const [TableData, setTableData] = useState(null);
  const navigate = useNavigate();

  const { data, loading, refetch } = useQuery(GET_ALL_ADMIN_ADVERTISER, {
    variables: {
      input: {
        filter: selectedTab,
        itemsPerPage: 10,
        page: 1,
      },
    },
    onCompleted: () => {
      setTableData(data?.admin?.getAllAdvertisers.data);
    }
  });

  const tableHeader = [
    {
      title: "ADVERTISER",
    },
    {
      title: "EMAIL",
    },
    {
      title: "PHONE",
    },
    {
      title: "DATE",
    },
  ];

  //   function to handleRow
  const handleRow = () => {};

  const tableAdminData = useMemo(() => {
    if (!data?.admin?.getAllAdvertisers?.data) return [];
  
    return data?.admin?.getAllAdvertisers?.data.map((columnData) => ({
      id: columnData?.id,
      advertiser: columnData?.advertiser,
      email: columnData?.email,
      phone: columnData?.phone,
      published: "published",
      state: columnData?.state || "Active", // Ensure state exists
    }));
  }, [data]);


  const ActiveTableData = useMemo(
    () => tableAdminData.filter((row) => row?.state === "Active"),
    [tableAdminData]
  );
  
  const InactiveTableData = useMemo(
    () => tableAdminData.filter((row) => row?.state === "Inactive"),
    [tableAdminData]
  );
  
  const activeCampaignTableData = useMemo(
    () => tableAdminData.filter((row) => row?.state === "Active Campaigns"),
    [tableAdminData]
  );


  //TABS LIST
  let tabs = [
    {
      key: "All",
      value: "ALL",
      total: data?.admin.getAllAdvertisers?.allCount || 0,
    },
    {
      key: "Active",
      value: "ACTIVE",
      total: data?.admin.getAllAdvertisers?.activeCount || 0,
    },
    {
      key: "Inactive",
      value: "INACTIVE",
      total: data?.admin.getAllAdvertisers?.inActiveCampaignCount || 0,
    },
    {
      key: "Active Campaigns",
      value: "CAMPAIGN_ACTIVE",
      total: data?.admin.getAllAdvertisers?.activeCampaignCount || 0,
    },
  ];

  
  useEffect(() => {
    if (selectedTab === "Active") {
      setTableData(ActiveTableData);
    } else if (selectedTab === "Inactive") {
      setTableData(InactiveTableData);
    } else if (selectedTab === "Active Campaigns") {
      setTableData(activeCampaignTableData);
    } else {
      setTableData(tableAdminData);
    }
  }, [selectedTab, tableAdminData, TableData]);

  

  return (
    <AdminDashboardLayout>
      {loading ? (
        <ChakraProvider>
          <Center h="100vh">
            <TableSpinner />
          </Center>
        </ChakraProvider>
      ) : (
        <Box h="100%" bg="#fff">
          {/* TAB SECTION */}

          <AdminTab
            tabs={tabs}
            setSelectedTab={setSelectedTab}
            selectedTab={selectedTab}
            tableAdminData={tableAdminData}
          />

          {/* Table section */}
          {/* <div>
                <div className="panelTab_wrapper"> */}
          <AdminTable
            header={tableHeader}
            data={TableData || []}
            loading={loading}
            refetch={refetch}
            showFilter={true}
            selectedTab={selectedTab}
            handleRow={handleRow}
            handleNavigate={(id) => navigate(`/admin/advertiser/profile/${id}`)}
            isAdvertiser={true}
          />
          {/* </div>
              </div> */}
        </Box>
      )}
    </AdminDashboardLayout>
  );
};

export default AdminAdvertiser;
